import React, { useEffect, useState, useRef } from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router";
import Style from "./Header.module.css";
import logo from "../../assets/hanshi/full-sm.svg";
import Breadcrumbs from "../controls/breadcrumb/Breadcrumb";
import Search from "./CustomSearch";
import TopBarUserIcon from "./TopbarUserIcon";
import Logo from "../logo/Logo";
import { callLogout } from "../../store/actions/auth.actions";
import Avatar from "../../components/controls/avatar/Avatar";
import styles from "./HeaderStyles.module.scss";
import { AlarmIcon, BellIcon, MessageIcon } from "../../modules/default-svg";
import Drawer from "../controls/drawer/Drawer";
import NotificationsDrawer from "../notificationsDrawer/NotificationsDrawer";
import RemindersDrawer from "../remindersDrawer/RemindersDrawer";
import NotificationModals from "../notificationsDrawer/NotificationsModals";
import { Badge } from "@fluentui/react-components";
import {
  notificationsList,
  reminders,
  createdReminders
} from "../../store/selectors/general.selector";
import { DateSelector } from "./Events/DateSelector/DateSelector";
import { getReminders } from "../../store/actions/general.actions";
import VoiceAssistant from "../voiceAssistant/VoiceAssistant";

const Header = (props) => {
  const { user, getLogo } = props;
  const [show, setShow] = useState(false);
  const [userInfo, setUserInfo] = useState(JSON.parse(user));
  const dispatch = useDispatch();
  const history = useHistory();
  const envr = process.env.REACT_APP_ENV;
  const popoverRef = useRef(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [notification, setNotification] = useState("");
  const [modalType, setModalType] = useState("");
  const [isCreate, setIsCreate] = useState(true);

  const remindersList = useSelector(reminders);
  const dueReminders = remindersList && typeof remindersList !== "string" ? remindersList : [];
  const remindersCount = dueReminders.length > 0 ? dueReminders.filter((r) => !r.isRead).length : 0;

  const createdRemindersList = useSelector(createdReminders);
  const createdByMeReminders = createdRemindersList && typeof createdRemindersList !== "string" ? createdRemindersList : [];
  const createdRemindersCount = createdByMeReminders.length > 0 ? createdByMeReminders.length : 0;

  let notificationlist = useSelector(notificationsList);
  notificationlist = notificationlist && typeof notificationlist !== "string" ? notificationlist : [];
  const notificationcount = notificationlist.length > 0 ? notificationlist.filter((r) => !r.isRead).length : 0;
  const path = window.location.pathname;

  const handleClickOutside = (event) => {
    if (popoverRef.current && !popoverRef.current.contains(event.target)) {
      setShow(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const logoClicked = () => {
    history.push(`/${envr}/dashboard`);
  };

  const handleLogout = () => {
    dispatch(callLogout());
    history.push("/");
  };

  const handleAccountInfo = () => {
    history.push(`/account`);
  };

  useEffect(() => {
    setUserInfo(JSON.parse(user));
  }, [user]);

  const refreshReminders = () =>{
    dispatch(getReminders());
  }
  return (
    <>
      <header className={styles.headerWrapper} ref={popoverRef}>
        <div className={styles.headerContent}>
          <div className="logoSection d-flex align-items-center">
            <div className={styles.logoIconWrapper} onClick={logoClicked}>
              <img src={logo} alt="logo" />
            </div>
            <VoiceAssistant />
            {!path.includes("reminders") && !path.includes("notifications") && (
              <Breadcrumbs />
            )}
          </div>
          <div className={styles.headerRightBar}>
            {/* <Search /> */}
            <div className={styles.iconsWrapper}>
              <div className="p-1 cursor-pointer">
                <DateSelector onDateRangeChange={() => { }} />
              </div>
              <div className="p-1 cursor-pointer">
                <MessageIcon />
              </div>
              <div className="p-1 cursor-pointer">
                <Drawer
                  DrawerTrigger={
                    <div className="d-flex" onClick={refreshReminders}>
                      <span style={{ position: "relative" }}>
                        <AlarmIcon />
                      </span>
                      <span
                        style={{
                          position: "absolute",
                          top: "1px",
                          marginLeft: "15px",
                        }}
                      >
                        {remindersCount > 0 && (
                          <Badge
                            className={`CounterBadgeWrap_small CounterBadgeWrap`}
                            appearance="filled"
                            size="small"
                            shape="circular"
                          >
                            {remindersCount}
                          </Badge>
                        )}
                      </span>
                    </div>
                  }
                  DrawerTitle="Reminders"
                  DrawerBodyArea={
                    <RemindersDrawer
                      dueReminders={dueReminders}
                      createdByMeReminders={createdByMeReminders}
                      setIsModalOpen={setIsModalOpen}
                      setReminder={setNotification}
                      modalType={setModalType}
                      setIsCreate={setIsCreate}
                    />
                  }
                />
              </div>
              <div className="p-1 cursor-pointer">
                <Drawer
                  DrawerTrigger={
                    <div className="d-flex">
                      <span style={{ position: "relative" }}>
                        <BellIcon />
                      </span>
                      <span
                        style={{
                          position: "absolute",
                          top: "1px",
                          marginLeft: "15px",
                        }}
                      >
                        {notificationcount > 0 && (
                          <Badge
                            className={`CounterBadgeWrap_small CounterBadgeWrap`}
                            appearance="filled"
                            size="small"
                            shape="circular"
                          >
                            {notificationcount}
                          </Badge>
                        )}
                      </span>
                    </div>
                  }
                  DrawerTitle="Notifications"
                  DrawerBodyArea={
                    <NotificationsDrawer
                      setIsModalOpen={setIsModalOpen}
                      setNotification={setNotification}
                      modalType={setModalType}
                    />
                  }
                />
              </div>
              <TopBarUserIcon
                show={show}
                handleToggle={setShow}
                user={userInfo}
              />
            </div>
          </div>

          {show && (
            <div className={Style.profileCard}>
              <div className={`${Style.logoWrapper}`}>
                <Logo cssClass={Style.logoStyle} logo={getLogo} />
                <p className="text-xsm-400" onClick={handleLogout}>
                  Sign out
                </p>
              </div>
              <div className={Style.profileWrapper}>
                {userInfo.profilePictureUrl !== null ? (
                  <img
                    src={userInfo.profilePictureUrl}
                    className={Style.profilePiCard}
                    alt=""
                  />
                ) : (
                  <Avatar
                    name={userInfo ? userInfo.fullName : ""}
                    cssClass={Style.initialsAvatar}
                  />
                )}
                <div className={Style.userInfoWrapper}>
                  <p className="text-md-600">
                    {userInfo ? userInfo.fullName : ""}
                  </p>
                  <p className="mb-2 text-xsm-400">
                    {userInfo ? userInfo.email : ""}
                  </p>
                  <p className="mb-0 text-xsm-400" onClick={handleAccountInfo}>
                    My account
                  </p>
                </div>
              </div>
            </div>
          )}
        </div>
      </header>
      {isModalOpen && (
        <NotificationModals
          setIsModalOpen={setIsModalOpen}
          notification={notification}
          modalType={modalType}
          isCreate={isCreate}
        />
      )}
    </>
  );
};

export default Header;
